import React from 'react';
import PropTypes from 'prop-types';

import { SmarticoMissionSkeleton } from '@atlas/ui';

const SmarticoMissionsLoading = ({ cardsCount }) => {
  const cards = Array.from({ length: cardsCount });

  return (
    <div className="smartico-missions-list__container">
      {cards.map((_, index) => (
        <SmarticoMissionSkeleton key={index} showDescription size="medium" />
      ))}
    </div>
  );
};

SmarticoMissionsLoading.propTypes = {
  cardsCount: PropTypes.number.isRequired,
};

export default SmarticoMissionsLoading;
